import React, { createContext, useContext } from "react";

const themes = {
  default: {
    gradient: "from-slate-700 to-slate-800",
    button: "bg-slate-700 hover:bg-slate-600",
    box: "bg-slate-50",
    text: "text-slate-800",
    textSecondary: "text-slate-600",
  },
};

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  return (
    <ThemeContext.Provider value={{ theme: themes.default }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
